import type { DatasheetWarning } from "@/lib/datasheets";

/// Surfaces both legacy's negative-balance warnings and v2's ledger-drift detection. Drift means
/// someone edited an available quantity directly without recording an adjustment, so the stored
/// balance and the statement disagree — the user needs to be told, not silently shown two numbers.
export function DatasheetWarningBanner({ warnings }: { warnings: DatasheetWarning[] }) {
  if (warnings.length === 0) return null;

  return (
    <div
      role="status"
      className="rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-100"
    >
      <p className="font-medium">Balances need attention</p>
      <ul className="mt-1 list-disc pl-5">
        {warnings.map((w, i) => (
          <li key={`${w.code}-${i}`}>{w.message}</li>
        ))}
      </ul>
    </div>
  );
}
